import { useEffect, useMemo, useState } from 'react';
import { ReorderBody } from 'app/components/DraggableListRow/types';
import { PlaylistAudio } from 'types/playlists.types';
import { movePlaylistAudioEffect } from 'app/store/Playlists/effects';
import { useDraggableRowRenderer } from 'app/components/DraggableListRow/hooks';
import { useAppDispatch } from 'app/store';

export const useAudiosListReorder = (audios: PlaylistAudio[]) => {
  const dispatch = useAppDispatch();
  const [rows, setRows] = useState<PlaylistAudio[]>(audios);

  const draggableRows = useMemo(
    () =>
      rows.map((row) => ({
        ...row,
        tooltip: row.audio.title,
      })),
    [rows]
  );

  const onReorder = async (data: ReorderBody, reordered: PlaylistAudio[]) => {
    const result = await dispatch(
      movePlaylistAudioEffect({ reorder: data, reordered })
    );
    return result.type === `${movePlaylistAudioEffect.typePrefix}/fulfilled`;
  };

  const {
    RowRenderer,
    tooltipTitle,
    onDragging,
    onRowReorder,
  } = useDraggableRowRenderer<PlaylistAudio>({
    rows: draggableRows,
    setRows,
    onReorder,
  });

  useEffect(() => {
    setRows(audios);
  }, [audios]);

  return {
    RowRenderer,
    tooltipTitle,
    setRows,
    rows,
    onDragging,
    onRowReorder,
  };
};
